export const OtherRestaurantData = [
    "Surat",
    "Ahmedabad",
    "Madurai",
    "Ooty",
    "Vijaywada",
    "Hyderabad",
    "Kanpur",
    "Trivandrum",
    "Nagpur",
    "Visakhapatnam",
    "Raipur",
    "Delhi NCR",
    "Rishikesh",
    "Chennai",
    "Simla",
    "Allahabad",
    "Kolkata",
    "Agra",
    "Haridwar",
    "Chandigarh",
    "Bhubaneshwar",
    "Varanasi",
    "Gorakhpur",
    "Jodhpur",
    "Jalandhar",
    "Kozhikode",
    "Goa",
    "Aurangabad",
    "Mumbai",
    "Coimbatore",
    "Leh",
    "Patna",
    "Dehradun",
    "Lucknow",
    "Ludhiana",
    "Kota",
    "Palakkad",
    "Jammu",
    "Alappuzha",
    "Indore",
    "Bhopal",
    "Mysore",
    "Guwahati",
    "Pushkar",
    "Udaipur",
    "Kochi",
    "Bengaluru",
    "Mangalore",
    "Ajmer",
    "Trissur",
    "Manali",
    "Thane",
    "Amritsar",
    "Vadodara",
    "Cuttack",
    "Ranchi",
    "Rajkot",
    "Pune",
    "Jaipur",
    "Nashik",
    "Puducherry",
    "Mussoorie",
    "Dharamshala",
    "Manipal",
] 